import { render, staticRenderFns } from "./LabelReleasesDeliveryDialog.vue?vue&type=template&id=763fed47"
import script from "./LabelReleasesDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./LabelReleasesDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelReleasesDeliveryDialog.vue?vue&type=style&index=0&id=763fed47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports